// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: 18px;\n  bottom: 0px;\n  height: 100%;\n}\n.discount-error {\n  width: 100%;\n  position: absolute;\n  bottom: -20px;\n}", ""]);
// Exports
module.exports = exports;
